import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { MessageCircle, Mail, Clock } from "lucide-react";

const Support = () => (
  <div className="min-h-screen bg-background">
    <Navbar />
    <main>
      <section className="pt-40 md:pt-52 px-6 md:px-10">
        <div className="max-w-6xl mx-auto">
          <span className="text-xs uppercase tracking-[0.18em] text-muted-foreground">Support</span>
          <h1
            className="mt-6 text-4xl md:text-6xl leading-[1.05] tracking-tight max-w-3xl"
            style={{ fontFamily: "var(--font-body)" }}
          >
            We're here to help.
          </h1>
          <p className="mt-6 text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl">
            Reach out to our team for questions, onboarding help or technical support.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-28 px-6 md:px-10">
        <div className="max-w-6xl mx-auto grid sm:grid-cols-3 gap-4">
          <div className="rounded-2xl border border-border bg-card p-6">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-foreground/[0.06] text-foreground">
              <MessageCircle className="h-5 w-5" />
            </span>
            <h2 className="mt-4 text-lg font-semibold text-foreground">Live chat</h2>
            <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
              Chat with us directly from your Bigdelta workspace during business hours.
            </p>
          </div>
          <div className="rounded-2xl border border-border bg-card p-6">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-foreground/[0.06] text-foreground">
              <Mail className="h-5 w-5" />
            </span>
            <h2 className="mt-4 text-lg font-semibold text-foreground">Email</h2>
            <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
              Send questions to support@bigdelta.com. We typically reply within one business day.
            </p>
          </div>
          <div className="rounded-2xl border border-border bg-card p-6">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-foreground/[0.06] text-foreground">
              <Clock className="h-5 w-5" />
            </span>
            <h2 className="mt-4 text-lg font-semibold text-foreground">Response times</h2>
            <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
              Priority support for paid plans. Free plans get help via email and documentation.
            </p>
          </div>
        </div>
      </section>
    </main>
    <Footer />
  </div>
);

export default Support;
